import { Table } from 'antd';
import styled from 'styled-components';
import { PlanogramWithChanges } from './columns';

export const ContainerArea = styled.div`
    width: 100%;
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding: 0px 24px;
    position: relative;
    scrollbar-width: none;
    -ms-overflow-style: none;
    position: relative;
    overflow: auto;
    margin-bottom: 12px;

    &::-webkit-scrollbar {
        display: none;
    }

    padding-bottom: 40px;
`;

export const TableWrapeer = styled.div`
    flex: 1;
`;

export const StyledTable = styled(Table<PlanogramWithChanges>)`
    .ant-table-container {
        border-radius: 8px;
    }
    .ant-table {
        border-radius: 8px;
        overflow: hidden;
    }

    .ant-table-row {
        font-size: 13px !important;
    }

    tr.row-invalid {
      cursor: not-allowed;
    }

    tr.row-delete {
      background-color: #ffdede !important;
    }

    tr.row-delete > td.ant-table-cell {
       background-color: #ffdede !important;
    }

    tr.row-invalid:hover {
      background: inherit !important;
    }

    .ant-table-thead > tr:first-child > th:first-child {
        border-top-left-radius: 8px;
    }

    .ant-table-thead > tr:first-child > th:last-child {
        border-top-right-radius: 8px;
    }

    .ant-table-thead > tr > th {
        padding: 16px !important;
    }

    .ant-table-thead > tr > th:not(:last-child) {
        border-right: none !important;
    }

    .ant-table-thead > tr > th:not(:last-child) {
        border-bottom: none !important;
    }


    .ant-table-tbody > tr > td:not(:last-child) {
       border-right: none !important;
    }

    .ant-table-tbody > tr:not(.ant-table-measure-row) > td {
        padding: 16px !important;
    }


    .ant-table-thead {
        > tr
        > th:not(:last-child):not(.ant-table-selection-column):not(
            .ant-table-row-expand-icon-cell
        ):not([colspan])::before {
        position: absolute;
        top: 50%;
        right: 0;
        width: 1px;
        height: 1.6em;
        background-color: rgba(0, 0, 0, 0.06) !important;
        transform: translateY(-50%);
        transition: background-color 0.3s;
        content: '';
    }
`;

export const StatusUnlocked = styled.span`
    display: inline-flex;
    align-items: center;
    height: 22px;
    padding: 4px 10px;
    border: 2px solid
        ${({ theme }) => (theme.theme === 'dark' ? '#389e0d' : '#b7eb8f')};
    border-radius: 4px;
    font-size: 13px;
    font-weight: 500;
    color: ${({ theme }) => (theme.theme === 'dark' ? '#95de64' : '#52c41a')};
    background: ${({ theme }) =>
        theme.theme === 'dark' ? 'rgba(56, 158, 13, 0.18)' : '#f6ffed'};
`;

export const StatusLocked = styled.span`
    display: inline-flex;
    align-items: center;
    padding: 4px 10px;
    height: 22px;
    border: 1px solid
        ${({ theme }) => (theme.theme === 'dark' ? '#cf1322' : '#ffa39e')};
    border-radius: 4px;
    font-size: 13px;
    font-weight: 500;
    color: ${({ theme }) => (theme.theme === 'dark' ? '#ff7875' : '#f5232d')};
    background-color: ${({ theme }) =>
        theme.theme === 'dark' ? 'rgba(207, 19, 34, 0.2)' : '#fff1f0'};
`;

export const OldValue = styled.span`
    text-decoration: line-through;
    color: inherit;
    font-weight: 400;
    color: #8c8c8c;
`;

export const NewValue = styled.span`
    color: inherit;
    font-weight: 600;
    display: inline-flex;
    gap: 6px;
`;

export const WrapperValue = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const ProductInfo = styled.div`
    display: flex;
    gap: 4px;
    flex-direction: column;
    width: 100%;
`;

export const BarCodeArea = styled.div`
    display: flex;
    align-items: center;
    color: #b0b0b0;
`;

export const StoreName = styled.span`
    font-size: 13px;
    color: #b0b0b0;
    font-weight: 500;
`;

export const PercentVariation = styled.span`
    font-size: 14px;
    font-weight: 400;
`;

export const ProductTitle = styled.span`
    font-size: 13px;
    color: #30374a;
    font-weight: 500;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 200px;
`;

export const ProductBarCode = styled(ProductTitle)`
    color: #b0b0b0;
`;

export const BlurredCell = styled.div<{ isInvalid?: boolean }>`
    position: relative;
    opacity: ${(props) => (props.isInvalid ? 0.5 : 1)};
    filter: ${(props) => (props.isInvalid ? 'blur(1px)' : 'none')};
    cursor: ${(props) => (props.isInvalid ? 'not-allowed' : 'default')};
`;
